import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../styles/Landing.css';

const LightningIcon = () => (
  <svg className="lightning-icon" viewBox="0 0 24 24" width="48" height="48">
    <defs>
      <linearGradient id="lightning-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#7bb8e8" />
        <stop offset="100%" stopColor="#6ba6d2" />
      </linearGradient>
    </defs>
    <path d="M13 0L4 13h7l-2 11L20 11h-7l3-11z" />
  </svg>
);

const Landing = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  React.useEffect(() => {
    if (currentUser) {
      navigate('/contacts');
    }
  }, [currentUser, navigate]);

  return (
    <div className="landing-container">
      <div className="landing-content">
        <div className="logo-container">
          <LightningIcon />
        </div>
        <h1 className="landing-title">
          Connect instantly with<br/>
          <span className="brand-name">PingIT</span>
        </h1>
        <p className="landing-description">
          Experience lightning-fast communication with our cutting-edge chat
          application. Stay connected with friends, family, and colleagues like
          never before.
        </p>
        <div className="landing-buttons">
          <button onClick={() => navigate('/login')} className="signin-button">
            Sign In
          </button>
          <button onClick={() => navigate('/signup')} className="signup-button">
            Sign Up
          </button>
        </div>
      </div>
    </div>
  );
};

export default Landing;
